const gsapController = async function () {
    const numberContent = !!document.querySelector(".number-content");
    const timeline = !!document.querySelector(".timeline-gsap");
    const parallaxSingleImage = !!document.querySelector(".parallax-single-image");
    const gridMove = !!document.querySelector(".grid-move");
    
    if ( numberContent || timeline || parallaxSingleImage || gridMove  ) {
        let gsap = await (await import('gsap')).default;

        // ScrollTrigger
        if ( numberContent || timeline || parallaxSingleImage || gridMove ) {
            let ScrollTrigger = await (await import('gsap/ScrollTrigger')).default;
            gsap.registerPlugin(ScrollTrigger);

            if ( numberContent ) {
                let AnimatedSection = await (await import('./gsap/numbers')).default;
                AnimatedSection(gsap, ScrollTrigger);
            }

            if ( timeline ) {
                let AnimatedSection = await (await import('./gsap/timeline')).default;
                AnimatedSection(gsap, ScrollTrigger);
            }

            if ( parallaxSingleImage ) {
                let AnimatedSection = await (await import('./gsap/parallax-single-image')).default;
                AnimatedSection(gsap, ScrollTrigger);
            }

            if ( gridMove ) {
                let AnimatedSection = await (await import('./gsap/grid-move')).default;
                AnimatedSection(gsap, ScrollTrigger);
            }
        }
    }
};

export const init = gsapController;